<!-- A small icon for a revealed moment, keyed by the moment id from level-gen. -->
<template>
  <svg viewBox="0 0 36 36" aria-hidden="true">
    <circle cx="18" cy="18" r="17" class="bg" />
    <template v-if="id === 'dinner'">
      <circle cx="18" cy="19" r="8" class="ink" />
      <circle cx="18" cy="19" r="4.5" class="hi" />
      <path d="M6 12 V26 M30 12 V26" class="stroke" />
    </template>
    <template v-else-if="id === 'call'">
      <rect x="8" y="11" width="16" height="13" rx="2" class="ink" />
      <path d="M24 15 L30 12 V24 L24 21 Z" class="ink" />
      <circle cx="16" cy="17" r="2.5" class="hi" />
    </template>
    <template v-else-if="id === 'bbq'">
      <rect x="8" y="17" width="20" height="6" rx="3" class="ink" />
      <path d="M12 23 L10 30 M24 23 L26 30" class="stroke" />
      <path d="M13 13 q2 -3 0 -6 M18 13 q2 -3 0 -6 M23 13 q2 -3 0 -6" class="stroke" />
    </template>
    <template v-else-if="id === 'ev'">
      <rect x="6" y="17" width="24" height="8" rx="2.5" class="ink" />
      <rect x="10" y="11" width="15" height="7" rx="2.5" class="ink" />
      <circle cx="11" cy="26" r="2.6" class="ink" />
      <circle cx="25" cy="26" r="2.6" class="ink" />
      <path d="M19 12 L16 18 H18.5 L16.5 23 L21 16 H18.5 Z" class="hi" />
    </template>
    <template v-else-if="id === 'solar'">
      <circle cx="18" cy="14" r="4.5" class="ink" />
      <path d="M18 5 V7 M27 14 H25 M11 14 H9 M24.4 7.6 L23 9 M11.6 7.6 L13 9" class="stroke" />
      <rect x="8" y="23" width="20" height="5" rx="1.5" class="ink" />
    </template>
    <template v-else-if="id === 'cool'">
      <path d="M8 18 q5 -5 10 0 t10 0 M8 25 q5 -5 10 0 t10 0 M8 11 q5 -5 10 0 t10 0" class="stroke" />
    </template>
    <template v-else-if="id === 'phone'">
      <rect x="12" y="7" width="12" height="22" rx="3" class="ink" />
      <path d="M15 17 L17.5 19.5 L22 14" class="stroke-hi" />
    </template>
    <template v-else>
      <path d="M18 7 L21 15 L29 16 L23 21 L25 29 L18 25 L11 29 L13 21 L7 16 L15 15 Z" class="ink" />
    </template>
  </svg>
</template>

<script setup>
defineProps({ id: { type: String, default: '' } });
</script>

<style scoped>
.bg { fill: var(--soc-window-glow); }
.ink { fill: var(--soc-sky-top); }
.hi { fill: var(--soc-window-glow); }
.stroke { fill: none; stroke: var(--soc-sky-top); stroke-width: 2.2; stroke-linecap: round; stroke-linejoin: round; }
.stroke-hi { fill: none; stroke: var(--soc-window-glow); stroke-width: 2.2; stroke-linecap: round; stroke-linejoin: round; }
</style>
